import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query MFATOTPGetUser($userId: ID) {
    mfaTotpGetUser(userId: $userId) {
      metadata {
        createdAt
      }
      userId
      isConfirmed
    }
  }
`
export const mfaTotpGetUserKey = getQueryNames(query)[0]

export default query
